<template lang="pug">
    div.container(
        :class="{'reverse': allItemsSelected}"
    )
        .revived-numbers-container(:style="isNeedMargin")
            .revived-numbers(
                v-if="showRevivedNumbersCells"
                v-for="(item, index) in revivedNumbersCells",
                :key="index"
            )
                img.revived-number(
                    v-if="showAssociatedImage(item)"
                    :src='item.image | apiFile')
                .revived-number(
                    v-else
                    :class="{ blink: item.active, 'revived-number-active': allItemsSelected, 'disabled': !allItemsSelected }"
                    @click="setNumber(item)"
                ) {{ item.digit }}
            .revived-numbers(
                v-if="showArrayOfNumbers"
                v-for="(item, index) in arrayOfNumbers",
                :key="index"
            )
                .revived-number(
                    :class="{'revived-number-active': allItemsSelected, 'disabled': !allItemsSelected }"
                    @click="setNumber(item)"
                ) {{ item.digit }}
        .images-container
            .images(
                v-for="(item ,index) in showImages"
                :key='index'
            )
                img.image(
                    v-if="showRandomAndAssociatedImage(item)"
                    :src='item.value | apiFile'
                    @click="setAssociation(item)"
                    :class="{ 'image-active': !allItemsSelected, 'disabled': allItemsSelected, blink: item.active && allItemsSelected, red: !item.correct && secondChance}"
                )
                .revived-number(v-if="showEmptyCell(item)"
                    :class="{ 'blink': item.active }"
                )
                .revived-number(
                    v-if="allItemsSelected && item.type === 'digit'"
                ) {{ item.digit }}
</template>

<script>
    export default {
        props: {
            secondChance: {
                type: Boolean,
                default: false,
            },
            filteredImages: {
                type: Array,
                default: () => [],
            },
            revivedNumbersCells: {
                type: Array,
                default: () => [],
            },
            checkAnswer: {
                type: Boolean,
                default: false,
            },
            amountOfNumbers: {
                type: Number,
                default: 0,
            },
            groupImages: {
                type: Array,
                default: () => [],
            },
            stepOfImagesShown: {
                type: Number,
                default: 0,
            },
            allItemsSelected: {
                type: Boolean,
                default: false,
            },
            selectedImages: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                arrayOfNumbers: [
                    { digit: 0 },
                    { digit: 1 },
                    { digit: 2 },
                    { digit: 3 },
                    { digit: 4 },
                    { digit: 5 },
                    { digit: 6 },
                    { digit: 7 },
                    { digit: 8 },
                    { digit: 9 },
                ],
            };
        },
        methods: {
            showAssociatedImage(item) {
                return item.image && !this.allItemsSelected && item.type === 'images';
            },
            showRandomAndAssociatedImage(item) {
                return (
                    (!item.empty && this.allItemsSelected && item.type === 'images' && !item.correct) ||
                    (!this.allItemsSelected && this.selectedImages.length < this.amountOfNumbers)
                );
            },
            showEmptyCell(item) {
                return item.empty && this.allItemsSelected && item.type === 'empty' && !item.correct;
            },
            setAssociation(item) {
                this.$emit('setAssociation', item);
            },
            setNumber(item) {
                this.$emit('setNumber', item);
            },
        },
        computed: {
            isNeedMargin() {
                const screenWidth = window.screen.width;
                if (
                    this.showArrayOfNumbers &&
                    this.revivedNumbersCells.length > 14 &&
                    screenWidth < 1400 &&
                    screenWidth >= 992
                ) {
                    return { marginTop: 130 + 'px' };
                } else {
                    return { marginTop: 35 + 'px' };
                }
            },
            showArrayOfNumbers() {
                return !this.checkAnswer && this.allItemsSelected;
            },
            showRevivedNumbersCells() {
                return !this.checkAnswer && !this.allItemsSelected;
            },
            showImages() {
                if (this.allItemsSelected) {
                    return this.filteredImages;
                }
                return this.groupImages.slice(this.stepOfImagesShown * 3, this.stepOfImagesShown * 3 + 3);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-right: 40px;
        padding-left: 40px;
    }
    .reverse {
        flex-direction: column-reverse;
    }

    .red {
        border: 2px solid $hsl_color_red-62 !important;
    }

    .images-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        max-width: 90%;
        margin-top: 20px;
    }
    .images {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        font-size: 60px;
        line-height: 73px;
    }
    .image {
        color: #6bbd6c;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #e6e6f8;
        border-radius: 10px;
        margin-top: 6px;
        margin-left: 6px;
        width: 45px;
        height: 45px;
        font-size: 30px;
        line-height: 35px;
        @include media($md) {
            margin-top: 8px;
            margin-left: 8px;
            width: 60px;
            height: 60px;
            font-size: 45px;
            line-height: 50px;
        }
        @include media($lg) {
            margin-top: 12px;
            margin-left: 12px;
            width: 95px;
            height: 95px;
            font-size: 60px;
            line-height: 73px;
        }
    }

    .disabled {
        pointer-events: none;
    }

    .images-active {
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
        cursor: pointer;
    }

    .images-active::after {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    }
    .image-active:hover {
        transform: scale(1.2, 1.2);
    }
    .image-active:hover::after {
        opacity: 1;
    }

    .revived-number-active {
        cursor: pointer;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    }

    .revived-number-active::after {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    }
    .revived-number-active:hover {
        transform: scale(1.2, 1.2);
    }
    .revived-number-active:hover::after {
        opacity: 1;
    }

    .revived-numbers-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
    }
    .revived-numbers {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }
    .revived-number {
        background-color: $x-color-white;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #6bbd6c;
        font-weight: 700;
        border: 2px solid #e6e6f8;
        border-radius: 10px;
        margin-top: 6px;
        margin-left: 6px;
        width: 45px;
        height: 45px;
        font-size: 30px;
        line-height: 35px;
        @include media($md) {
            margin-top: 8px;
            margin-left: 8px;
            width: 60px;
            height: 60px;
            font-size: 45px;
            line-height: 50px;
        }
        @include media($lg) {
            margin-top: 12px;
            margin-left: 12px;
            width: 95px;
            height: 95px;
            font-size: 60px;
            line-height: 73px;
        }
    }
    .active {
        background-color: #00b14f !important;
    }

    @import '@/assets/sass/animations/blink.scss';
</style>
